module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "has-dropdown",
    class: _vm.openedClass
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    domProps: {
      "textContent": _vm._s(_vm.label)
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.open(_vm.id)
      }
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "dropdown"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3ac08f2f!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/js/src/components/Navigation/DropDownWrapper.vue
// module id = 411
// module chunks = 0